<template>
    <div>
        <ul aria-label="This attraction is featered in the follow:">
            <a v-for="badge in badges" :key="badge.name" :href="badge.page">
                <li><img :src="badge.imageUrl" :alt="badge.name"/></li>
            </a>
        </ul>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
class Badges extends Vue {
    @Prop({
      type: Array,
      required: true,
    })
    badges;
}

export default Badges;
</script>

<style scoped>

ul {
    display: flex;
    flex-direction: row;
    list-style: none;
    margin: 30px 0;
    padding: 0;
}

li {
    padding: 0 15px 0 0;
}
li img {
    width:75px;
}


</style>
